import { themes as colorsThemes } from "../colors/themes/themes";
import { themes as iconsThemes } from "../icons/themes/themes";
import { Themes, UserGroup } from "./types";

const USER_GROUPS: UserGroup[] = [
  "free",
  "premium",
  "plurall",
  "goStudentLearning"
];

export const themes = USER_GROUPS.reduce((acc, userGroup) => {
  const theme = {
    colors: colorsThemes[userGroup],
    icons: iconsThemes[userGroup]
  };
  acc[userGroup] = theme;
  return acc;
}, {} as Themes);
